import { all } from 'axios';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "english": "English ",
          "arabic": "العربیە ",
          "kurdish": "کوردی ",
          "turkish": "ترکی ",
          "home": "Home",
          "about": "About Us",
          "contact": "Contact",
          "language": "Language",
          "ourStory": "Our Story",
          "doctors": "Doctors",
          "activities": "Activities",
          "publishments": "Publications",
          "gallery": "Gallery",
          "donate": "Contribute",
          "zad organization": "Zad UK & Internationals",
          "zad": "Zad UK & Internationals",
          "organization": "Organization",
          "latestNews": "Latest Activity",
          "zadStatistics": "Zad Statistics",
          "ourTeam": "Our Team",
          "ourPublications": "Our Publications",
          "readMore": "Read More",
          "latestUpdate": "Latest Update",
          "surgeries": "Surgeries",
          "YearExp": "Year ",
          "viewProfile": "View Profile",
          "projects": "Projects",
          "branches": "Branches",
          "seeMore": "See More",
          "whoWeAre": "Who We Are",
          "whatCanYouDo": "What You Can Do",
          "who_we_are": "Who We Are",
          "what_can_you_do": "What You Can Do",
          "zakatCalculation": "Zakat Calculation",
          "rate": "Nisab Rate",
          "priceGoldOrSilver": "Gold/Silver Price",
          "cashMoney": "Cash Money",
          "debtMoney": "Debt Money",
          "companyMoney": "Company Money",
          "bankMoney": "Bank Balance",
          "investerMoney": "Investment Amount",
          "anotherMoney": "Other Assets",
          "totalMoney": "Total Money",
          "ZakatCalculator": "Zakat Calculator",
          "giveZakatNow": "Give Zakat Now",
          "zakat": "Zakat",
          "phone": "Phone",
          "email": "Email",
          "Location": "Location",
          "title": "Title",
          "description": "Description",
          "download": "Download",
          "content": "Content",
          "cases": "Cases",
          "all": "All",
          "unit": "Cooperators",
          drug: "Drug",
          check: "Check",
          m_supplies: "Medical Supplies",
          surgery: "Surgery",
          "viewOnMap": "View on Map",
          "needZad": "Benefit from Zad ",
          "registerPatient": "Benefit from Zad as a patient",
          "becomeVolunteer": "Help Zad with your human resources",
          "patientDescription": "If you need surgery or medical supplies, register and you will be contacted by our committees after follow-up",
          "volunteerDescription": "You can become a Zad volunteer and help Zad with your skills and human resources",
          "beVolunteer": "Join as Volunteer",
          "needZadTitle": "How Can We Help You?",
          "needZadSubtitle": "Choose one of these to benefit from Zad",
          "needZadFooter": "Your journey to better health starts here",
          "fullName": "Full Name",
          "gender": "Gender",
          "birthDate": "Date of Birth",
          "medicalCondition": "Medical Condition",
          "address": "Address",
          "Male": "Male",
          "Female": "Female",
          "other": "Other",
          "submit": "Submit Registration",
          "cancel": "Cancel",
          "modalSubtitle": "Please provide your information so we can assist you",
          "fullNamePlaceholder": "Enter your full name",
          "phonePlaceholder": "Enter your phone number",
          "conditionPlaceholder": "Describe your medical condition",
          "addressPlaceholder": "Enter your full address",
          "submitting": "Submitting...",
          "registrationSuccess": "Registration submitted successfully! We'll contact you soon.",
          "selectYourBranch": "Select Your Branch",
          "success": "Your information has been stored successfully",
          branch: "Branch",
          register: "Registration",
          registerVolunteer: "Become a Zad volunteer",
          otherActivity: "Other Activity",
          "loadMore": "Load More",
          year: "Year",
          month: "Month",
          day: "Day",
          hour: "Hour",
          minute: "Minute",
          second: "Second",
          "numberOfAnimals": "Number of animals",
          "pricePerHead": "Price per head",
          "totalAnimals": "Total animals",
          "zakatResult": "Zakat result",
          "zakatInCurrency": "Zakat (currency)",
          "weightKg": "Weight (kg)",
          "pricePerKg": "Price per kg",
          "rain": "Rain",
          "irrigated": "Irrigated",
          "mixed": "Mixed",
          "sheep": "Sheep",
          "cow": "Cow",
          "camel": "Camel",
          "crops": "Crops",
          justNow: "just now",
          "ago": "ago",
          'paidAmount': "Paid Amount",
          'total': "Total",
          "moneyNeed": "Money Need",
          "animalOrCorn": "Animal / Corn",
          "corn": "Corn",
          "selectYear": "Select Year",
          "location": "Location",
          "humanity": "Zad for human revival",
          "popularSearches": "Popular Searches",
          "close": "Close",
          "searchPlaceholder": "Search Here",
          "search": "Search",
          "animalZakat": "Animal Zakat",
          "cropsZakat": "Crop Zakat",
          'goat': "Goat",
          "oneYearOldCow": "One Year Old Cow",
          "twoYearOldCow": "Two Year Old Cow",
          "and": "and",
          "oneCam1Year": "camel (1 year)",
          "oneCam2Years": "camel (2 years)",
          "oneCam3Years": "camel (3 years)",
          "cam4Years": "camel (4 years)",
          "twoYearOldCam": "2-year-old camel",
          "threeYearOldCam": "3-year-old camel",
          "merGroup": "5-camels group (mer)",
          "sixMonths": "6 months",
          "and": "and",
          "or": "or",
          "irrigation": "Type of grain irrigation",
          "date": "Date",
          "zakatAmount": "Amount of Zakat ",
          "MinistryOfReligiousAssembly": "Please contact the Ministry of Religious Assembly",
          "zakatAmountAnimals&Crops": "Amount of Zakat (Animals and Crops)",
          "Fully_Funded":"Fully Funded",
          Remaining:"Remaining",
        }
      },
      ar: {
        translation: {
          "Fully_Funded":"تم التمويل",
          Remaining:"المتبقى",
          "viewOnMap": "عرض على الخريطة",
          "english": "English ",
          "arabic": "العربیە ",
          "kurdish": "کوردی ",
          "turkish": "ترکی ",
          "home": "الرئيسية",
          "about": "حولنا",
          "contact": "اتصل بنا",
          "language": "اللغة",
          "ourStory": "قصتنا",
          "doctors": "الأطباء",
          "activities": "الأنشطة",
          "publishments": "المنشورات",
          "gallery": "المعرض",
          "donate": "contribute",
          "zad organization": "Zad UK & Internationals",
          "zad": "Zad UK & Internationals",
          "organization": "منظمة",
          "latestNews": "آخر الأنشطة",
          "zadStatistics": "إحصائيات زاد",
          "ourTeam": "فريقنا",
          "ourPublications": "منشوراتنا",
          "readMore": "اقرأ المزيد",
          "latestUpdate": "آخر تحديث",
          "surgeries": "العمليات",
          "YearExp": "سنوات ",
          "viewProfile": "عرض الملف الشخصي",
          "projects": "المشاريع",
          "branches": "الفروع",
          "seeMore": "عرض المزيد",
          "whoWeAre": "من نحن",
          "whatCanYouDo": "ماذا يمكنك أن تفعل",
          "who_we_are": "من نحن",
          "what_can_you_do": "ماذا يمكنك أن تفعل",
          "zakatCalculation": "حساب الزكاة",
          "rate": "معدل النصاب",
          "priceGoldOrSilver": "سعر الذهب/الفضة",
          "cashMoney": "النقد",
          "debtMoney": "الديون",
          "companyMoney": "أموال الشركة",
          "bankMoney": "رصيد البنك",
          "investerMoney": "مبلغ الاستثمار",
          "anotherMoney": "أصول أخرى",
          "totalMoney": "إجمالي المال",
          "ZakatCalculator": "حاسبة الزكاة",
          "giveZakatNow": "ادفع الزكاة الآن",
          "zakat": "حاسبة الزكاة",
          "phone": "الهاتف",
          "email": "البريد الإلكتروني",
          "Location": "الموقع",
          "title": "العنوان",
          "description": "الوصف",
          "loadMore": "تحميل المزيد",
          "download": "تحميل",
          "content": "المحتوى",
          "cases": "الحالات",
          "all": "الكل",
          "unit": "المتعاونون",
          "needZad": "استفد من زاد",
          drug: "دواء",
          check: "فحص",
          m_supplies: "المستلزمات الطبية",
          surgery: "جراحة",
          "registerPatient": "استفد من زاد كمريض",
          "becomeVolunteer": " ساهم في زاد بتنمية مواردك البشرية",
          "patientDescription": "إذا كنت بحاجة إلى عملية جراحية أو مستلزمات طبية، يُرجى التسجيل وسيتم التواصل معك من قبل لجاننا بعد المتابعة.",
          "volunteerDescription": "يمكنك التطوع في زاد ومساعدتها بمهاراتك ومواردك البشرية.",
          "beVolunteer": "تطوع معنا",
          "needZadTitle": "كيف يمكننا مساعدتك؟",
          "needZadSubtitle": "اختر أحد الخيارات التالية للاستفادة من زاد",
          "needZadFooter": "رحلتك نحو صحة أفضل تبدأ من هنا",
          "fullName": "الاسم الكامل",

          "gender": "الجنس",
          "birthDate": "تاريخ الميلاد",
          "medicalCondition": "الحالة الطبية",
          "address": "العنوان",
          "Male": "ذكر",
          "Female": "أنثى",
          "other": "آخر",
          "submit": "تقديم التسجيل",
          "cancel": "إلغاء",
          "modalSubtitle": "يرجى تقديم معلوماتك حتى نتمكن من مساعدتك",
          "fullNamePlaceholder": "أدخل اسمك الكامل",
          "phonePlaceholder": "أدخل رقم هاتفك",
          "conditionPlaceholder": "صف حالتك الطبية",
          "addressPlaceholder": "أدخل عنوانك الكامل",
          "submitting": "جاري الإرسال...",
          "registrationSuccess": "تم تقديم التسجيل بنجاح! سنتصل بك قريباً.",
          "selectYourBranch": "اختر فرعك",
          "success": "تم تسجيلك بنجاح",
          "branch": "الفرع",
          register: "زر التسجيل",
          registerVolunteer: " تطوع في زاد ",
          "otherActivity": "الفعالية الاخرى",

          year: "سنة",
          month: "شهر",
          day: "يوم",
          hour: "ساعة",
          minute: "دقيقة",
          second: "ثانية",

          justNow: "الان",
          ago: "منذ",
          paidAmount: "المبلغ المدفوع",
          total: "المجموع",
          moneyNeed: "المبلغ المطلوب",
          "animalOrCorn": "حيوانات / حبوب",
          "corn": "حبوب",
          "type": "نوع",
          "statistic": "إحصائيات",
          "date": "تاریخ",
          "selectYear": "اختر السنة",
          "location": "الموقع",
          'humanity': 'زاد لإحياء الانسان',
          "numberOfAnimals": "عدد الحيوانات",
          "pricePerHead": "سعر كل رأس",
          "popularSearches": "البحث الشعبي",
          "totalAnimals": "إجمالي الحيوانات",
          "zakatResult": "نتيجة الزكاة",
          "zakatInCurrency": "الزكاة (بالعملة)",
          "weightKg": "الوزن (كجم)",
          "pricePerKg": "سعر لكل كجم",
          "rain": "مطر",
          "irrigated": "مروي",
          "mixed": "مختلط",
          "sheep": "غنم",
          "cow": "بقرة",
          "camel": "جمل",
          "crops": "محاصيل",
          "close": "اغلاق",
          "searchPlaceholder": "ابحث هنا",
          "search": "ابحث",
          "searchResult": "نتيجة البحث",
          "noResult": "لا يوجد نتائج",
          "noData": "لا يوجد بيانات",
          "animalZakat": "زكاة الحيوانات",
          "cropsZakat": "زكاة المحاصيل",
          "animal": "حيوان",
          "crop": "محصيل",
          goat: "عنزة",
          "oneYearOldCow": " بقرة سنة",
          "twoYearOldCow": "بقرة سنتين",
          "and": "و",
          "oneCam1Year": "جمل مخاض",     // أنثى من الإبل أتمت سنة
          "oneCam2Year": "جمل لبون",     // أنثى من الإبل أتمت سنتين
          "oneCam3Year": "حقّة",         // أنثى من الإبل أتمت ثلاث سنوات
          "oneCam4Year": "جذعة",          // أنثى من الإبل أتمت أربع سنوات
          "irrigation": "نوع ري الحبوب",
          "date": "تاریخ",
          "zakatAmount": "مقدار الزكاة ",

          "oneCam1Year": "(ناقة عمرها سنة (أنثى))",
          "oneCam2Years": "(ناقة عمرها سنتان (أنثى))",
          "oneCam3Years": "(ناقة عمرها 4 سنوات (أنثى))",
          "cam4Years": "(ناقة عمرها 4 سنوات (أنثى))",
          "twoYearOldCam": "(ناقة عمرها سنتان (أنثى))",
          "threeYearOldCam": "(ناقة عمرها 3 سنوات (أنثى))",

          "sixMonths": "(شاة عمره 6 أشهر (ذكر أو أنثى))",
          "or": "أو",
          "cows": "بقرات",
          "MinistryOfReligiousAssembly": "يرجى الاتصال بوزارة الشؤون الدينية",
          "zakatAmountAnimals&Crops": "مقدار الزكاة (الحيوانات و المحاصيل)",
        }
      },
      ckb: {
        translation: {
          "english": "English ",

          "arabic": "العربیە ",
          "kurdish": "کوردی ",
          "turkish": "ترکی ",
          "home": "سەرەتا",
          "about": "دەربارەی ئێمە",
          "contact": "پەیوەندی",
          "language": "زمان",
          "ourStory": "چیرۆکی ئێمە",
          "doctors": "پزیشکەکان",
          "activities": "چالاکییەکان",
          "publishments": "بڵاوکراوەکان",
          "gallery": "گەلەری",
          "donate": "contribute",
          "zad organization": "Zad UK & Internationals",
          "zad": "Zad UK & Internationals",
          "organization": "ڕێکخراوی",
          "latestNews": "دوایین چالاکییەکان",
          "zadStatistics": "ئاماری زاد",
          "statistic": "ئامار",
          "type": "جۆر",
          "date": "بەروار",
          "ourTeam": "پزیشکەکان",
          "ourPublications": "بڵاوکراوەکانمان",
          "readMore": "زیاتر",
          "latestUpdate": "کۆتا نوێکردنەوە ",
          "surgeries": "نەشتەرگەری",
          "YearExp": "ساڵ",
          "viewProfile": "بینینی پروفایل",
          "projects": "پرۆژەکان",
          "branches": "لقەکان",
          "seeMore": "بینینی زیاتر",
          "whoWeAre": "ئێمە کێین",
          "whatCanYouDo": "دەتوانن چی بکەن",
          "who_we_are": "ئێمە کێین",
          "what_can_you_do": "دەتوانن چی بکەن",
          "zakatCalculation": "زەکات ژمێر",
          "priceGoldOrSilver": "نرخە زێر/زیوو",
          "cashMoney": "پارەی کاش",
          "debtMoney": "پارەی قەرز",
          "companyMoney": "سەرمایەی کۆمپانیا",
          "bankMoney": "باڵانسی بانکی",
          "investerMoney": "وەبەرهێنان",
          "anotherMoney": "سەرچاوەی دیکە",
          "totalMoney": "کۆی گشتی",
          "ZakatCalculator": "هەژماری زەکات",
          "giveZakatNow": "ئێستا زەکات بدە",
          "zakat": "زەکات ژمێر",
          "phone": "ژمارە مۆبایل",

          "numberOfAnimals": "ژمارەی ئاژەڵەکان",
          "pricePerHead": "نرخی هەر دانەیەک",
          "totalAnimals": "کۆی گشتی ئاژەڵەکان",
          "zakatResult": "هەژماری زەکات",
          "zakatInCurrency": "جۆری دراوی زەکات",
          "weightKg": "کێش (کیلۆگرام)",
          "pricePerKg": "نرخی هەر کیلۆگرامێک",
          "rain": "باران",
          "irrigated": "ئاودێری",
          "mixed": "تێکەڵ",
          "sheep": "مەڕ",
          "cow": "مانگا",
          "camel": "حوشتر",
          "crops": "دانەوێڵە",



          "email": "ئیمەیڵ",
          "Location": "شوێن",
          "title": "ناونیشان",
          "description": "باسکردن",

          "download": "داگرتن",
          "content": "ناوەڕۆک",
          "cases": "بەخشینە تایبەتەکانی زاد",
          "all": "هەموو",
          "unit": "هاوکاران",
          'drug': "دەرمان",
          'check': "پشکنین",
          'm_supplies': "پێداویستی پزیشکی",
          'surgery': "نەشتەرگەری",
          "viewOnMap": "سەیرکردن لەسەر نەخشە",
          "needZad": "سودمەند بە",
          "registerPatient": "وەک نەخۆشێک سودمەندبە لە زاد",
          "becomeVolunteer": "بە توانا مرۆییەکەت هاوکاری زاد بکە",
          "patientDescription": "گەر پێویستت بە نەشتەرگەریی یاخود پێداویستی پزیشکییە ناوی خۆت تۆمار بکە و دوای بەدواداچوون لەلایەن لیژنەکانمانەوە پەیوەندیت پێوە دەکرێت",
          "volunteerDescription": "دەتوانیت ببیت بە خۆبەخشی ڕێکخراوی زاد و بە لێهاتوویی و توانا مرۆییەکەت هاوکاری زاد بکەیت",
          "beVolunteer": "بەشداری بکە",
          "needZadTitle": "چۆن هاوکاریت بکەین؟",
          "needZadSubtitle": "یەکێک لەمانە هەلبژێرە بۆ سودمەندبوون لە زاد",
          "needZadFooter": "گەشتت بۆ تەندروستی باشتر لێرە دەست پێدەکات",
          "fullName": "ناوی تەواو",
          "otherActivity": "چالاکی زیاتر",
          "gender": "رەگەز",
          "birthDate": "بەرواری لەدایکبوون",
          "medicalCondition": "دۆخی تەندروستی",
          "address": "ناونیشان",
          "Male": "نێر",
          "Female": "مێ",
          "other": "ئەویتر",
          "submit": "ناردنی تۆمار",
          "cancel": "هەڵوەشاندنەوە",
          "modalSubtitle": "تکایە زانیارییەکەت پێ بدەین تا بتوانین یارمەتیت بدەین",
          "fullNamePlaceholder": "ناوی تەواوت بنووسە",
          "phonePlaceholder": "ژمارەی مۆبایلەکەت بنووسە",
          "conditionPlaceholder": "دۆخی تەندروستی خۆت باس بکە",
          "addressPlaceholder": "ناونیشانی تەواوت بنووسە",
          "submitting": "لە ناردندایە...",
          "registrationSuccess": "تۆمارەکەت بە سەرکەوتوویی نێردرا! بەم نزیکانە پەیوەندیت پێوە دەکەین.",
          "selectYourBranch": "تکایە لقەکەت هەڵبژێرە",
          "success": "بەسەرکەوتووی کارەکە جێبەجێ کرا",
          branch: "لق",
          register: "تۆمارکردن",
          registerVolunteer: " ببە بە خۆبەخشی زاد ",

          year: "ساڵ",
          month: "مانگ",
          day: "رۆژ",
          hour: "کاتژمێر",
          minute: "خولەک",
          second: "چرکە",

          justNow: "ئێستا",
          ago: "پاش",
          paidAmount: "بڕی دابینکراو",
          "Fully_Funded":"بە تەواوی دابینکرا",
          Remaining:"بڕی ماوە",
          total: "کۆی گشتی",
          moneyNeed: "بڕی پێویست",

          "register_academy": "ئەکادیمیای زاد",
          "register_academy_description": "تکایە زانیارییەکانت پێشکەش بکە بۆ تۆمارکردنی ئەکادیمیای زاد",
          "animalOrCorn": "ئاژەڵ / دانەوێڵە",
          "corn": "دانەوێڵە",
          "selectYear": "دیاریکردنی ساڵ",
          "location": "ناونیشان",
          "humanity": "بۆ ژیانەوەی ئادەمیزاد",
          popularSearches: "گەڕانە باوەکان",
          "close": "داخستن",
          "searchPlaceholder": "گەڕان بکە",
          "search": "گەڕان",
          "animalZakat": "زەکاتی ئاژەڵ",
          "cropsZakat": "زەکاتی دانەوێڵە",
          "header": "سەر",
          "goat": "بزن",
          "oneYearOldCow": "مانگای یەک ساڵە",
          "twoYearOldCow": "مانگای دوو ساڵە",
          "and": "و",
          "twoYearOldCam ": "حوشتری دوو ساڵە",
          "oneCam2Years": "یەک حوشتر (دو ساڵە)",
          "oneCam3Years": "یەک حوشتر (سێ ساڵە)",
          "oneCam4Years": "یەک حوشتر (چوار ساڵە)",
          "irrigation": "جۆری ئاودانی دانەوێڵە",
          "zakatAmount": "بڕی زەکات",
          "cows": "مانگاکان",

          "oneCam1Year": "حوشتری 1 ساڵی مێ",
          "oneCam2Years": "حوشتری 2 ساڵی مێ",
          "oneCam3Years": "حوشتری 3 ساڵی مێ",
          "cam4Years": "حوشتری 4 ساڵی مێ",
          "loadMore": "بینینی زیاتر",
          "twoYearOldCam": "حوشتری 2 ساڵی مێ",
          "threeYearOldCam": "حوشتری 3 ساڵی مێ",

          "sixMonths": "تەمەن ٦ مانگ (نێر یان مێ)",
          "or": " و ",
          "cows": "مانگاكان",
          "MinistryOfReligiousAssembly": "بۆ وردەکاری زیاتر پەیوەندی بە وەزارەتی ئەوقاف بکە",
          "zakatAmountAnimals&Crops": "بڕی زەکاتی ئاژەڵ و دانەوێڵە",
        }
      },
      tr: {
        translation: {
          "english": "English ",
          "arabic": "العربیە ",
          "kurdish": "کوردی ",
          "turkish": "ترکی ",
          "home": "Ana Sayfa",
          "about": "Hakkımızda",
          "contact": "İletişim",
          "language": "Dil",
          "ourStory": "Hikayemiz",
          "doctors": "Doktorlar",
          "activities": "Etkinlikler",
          "publishments": "Yayınlar",
          "gallery": "Galeri",
          "donate": "contribute",
          "zad organization": "Zad UK & Internationals",
          "zad": "Zad UK & Internationals",
          "organization": "Organizasyon",
          "latestNews": "Son Haberler",
          "zadStatistics": "Zad Statistikleri",
          "ourTeam": "Takımımız",
          "ourPublications": "Yayınlarımız",
          "readMore": "Daha Fazla",
          "latestUpdate": "Son Güncelleme",
          "surgeries": "Tıbbi Hizmetler",
          "YearExp": "Yıllık ",
          "viewProfile": "Profilimı Görüntüle",
          "projects": "Projeler",
          "branches": "Brançlar",
          "seeMore": "Daha Fazla",
          "whoWeAre": "Ne Yapıyoruz",
          "whatCanYouDo": "Ne Yapabilirsiniz",
          "who_we_are": "Ne Yapıyoruz",
          "what_can_you_do": "Ne Yapabilirsiniz",
          "zakatCalculation": "Zekat Hesaplama",
          "rate": "Asgari Miktar",
          "priceGoldOrSilver": "Altın/Gümüş Fiyatı",
          "cashMoney": "Nakit",
          "debtMoney": "Borçlar",
          "companyMoney": "Şirket Sermayesi",
          "bankMoney": "Banka Bakiyesi",
          "investerMoney": "Yatırımlar",
          "anotherMoney": "Diğer Varlıklar",
          "totalMoney": "Toplam Tutar",
          "ZakatCalculator": "Zekat Hesaplayıcı",
          "giveZakatNow": "Şimdi Zekat Ver",
          "zakat": "Zakat",
          "phone": "Telefon",
          "email": "E-posta",
          "Location": "Konum",
          "title": "Başlık",
          "description": "Açıklama",
          "download": "İndir",
          "content": "İçerik",
          "cases": "Vaka",
          "all": "Tümü",
          "unit": "Unit",
          drug: "İlaç",
          check: "Kontrol",
          m_supplies: "Tıbbi Malzemeler",
          surgery: "Ameliyat",
          "viewOnMap": "Haritada Görüntüle",
          "needZad": "Zad'a ihtiyacım var",
          "registerPatient": "Hasta Kaydı",
          "becomeVolunteer": "Gönüllü Ol",
          "patientDescription": "Kendiniz veya ihtiyacı olan biri için tıbbi yardım alın",
          "volunteerDescription": "Ekibimize katılın ve tıbbi destek sağlamaya yardımcı olun",
          "beVolunteer": "Gönüllü Ol",
          "needZadTitle": "Size Nasıl Yardımcı Olabiliriz?",
          "needZadSubtitle": "ZAD ile başlamak için aşağıdan bir seçenek belirleyin",
          "needZadFooter": "Daha iyi bir sağlık yolculuğunuz burada başlıyor",
          "fullName": "Tam Adı",

          "gender": "Cinsiyet",
          "birthDate": "Doğum Tarihi",
          "medicalCondition": "Tıbbi Durum",
          "address": "Adres",
          "Male": "Erkek",
          "Female": "Kadın",
          "other": "Diğer",
          "submit": "Kaydı Gönder",
          "cancel": "İptal",
          "modalSubtitle": "Size yardımcı olabilmemiz için lütfen bilgilerinizi verin",
          "fullNamePlaceholder": "Tam adınızı girin",
          "phonePlaceholder": "Telefon numaranızı girin",
          "conditionPlaceholder": "Tıbbi durumunuzu açıklayın",
          "addressPlaceholder": "Tam adresinizi girin",
          "submitting": "Gönderiliyor...",
          "registrationSuccess": "Kayıt başarıyla gönderildi! Yakında sizinle iletişime geçeceğiz.",
          "selectYourBranch": "Brançınızı Seçin",
          "success": "Bilgileriniz başarıyla güncellendi",
          branch: "Branç",
          register: "Kayıt Ol",
          otherActivity: "Diger Etkinlikler",

          year: "Yıl",
          month: "Ay",
          day: "Gün",
          hour: "Saat",
          minute: "Dakika",
          second: "Saniye",
          "animalOrCorn": "ئاژەڵ / دانەوێڵە",
          "location": "konum",
        }
      }
    },
    supportedLngs: ['en', 'ar', 'ckb', 'tr'],
    fallbackLng: localStorage.getItem('lang') || 'en',
    debug: false,
    interpolation: { escapeValue: false },
  });

export default i18n;
